module.exports = __webpack_public_path__ + "img/Communities.266cd8ee.png";